import { HTTP, authHeader } from './http-service';
import moment from 'moment';

class DSARSearchService {
  search(payload) {
    return HTTP.post(`/DataSubjectAccessRequestSearch`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  advancedSearch(payload) {
    return HTTP.post(`/DataSubjectAccessRequestSearch/advance`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  exporDataProtectionCsv() {
    return HTTP.get(`/DataSubjectAccessRequestSearch/data-protection/csv`, {
      headers: authHeader(),
      responseType: 'blob',
    }).then((response) => {
      const blob = new Blob([response.data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${moment().format('DD.MM.YYYY')} BackOffice DataProtection.csv`;
      link.click();
      URL.revokeObjectURL(link.href);
      return Promise.resolve(response);
    });
  }
}

export default new DSARSearchService();
